import React from 'react';
import { Row } from 'components/ui/Grid';
import Text from 'components/ui/Text';
import PropTypes from 'prop-types';
import {
  CategoryLogo,
  CategoryDescription,
} from './CategorySection.style';

const CategorySection = ({ categoryName, categoryMedia, categoryDescription }) => (
  <>
    <Row fluid justifycontent="center">
      {categoryMedia ? (
        <CategoryLogo src={categoryMedia} alt={`Logo ${categoryName}`} />
      ) : undefined}
      <CategoryDescription>
        <Text tag="p" value={categoryDescription} margin="0" />
      </CategoryDescription>
    </Row>
  </>
);

CategorySection.displayName = 'Sezione categoria';

CategorySection.propTypes = {
  categoryDescription: PropTypes.string,
  categoryMedia: PropTypes.string,
  categoryName: PropTypes.string,
};

export default CategorySection;
